/**
 * External dependencies
 */
import { useMemo } from 'react';
import cloneDeep from 'lodash/cloneDeep';

/**
 * Internal dependencies
 */
import BaseRoutes from '@naruto/bgdapp/src/base/routes';
import { RouteItem } from '@naruto/bgdapp/src/base/routes/types';
import useMappedState from '@naruto/bgdapp/src/hooks/useMappedState';

interface useValidRoute {
  routes: RouteItem[];
  redirect: string;
}

/**
 * 描述 : 根據權限判斷是否有權限進入該路徑
 */

export default function useValidRoute(routeLayer: string[], signInRedirect = '', noSignInRedirect = ''): useValidRoute {
  /* Global & Local State */
  const storeUser = useMappedState(state => state.user);

  /* Data */
  const validRoutes: RouteItem[] = useMemo(() => {
    let fullRoutes: RouteItem[] = [];
    let result: RouteItem[] | null = null;
    let hadResult = false;
    if (storeUser.userIsLogin) {
      const filterValidRoute = (route: RouteItem): RouteItem | undefined => {
        if (!route.permissionsModule) {
          route.subRoute = route.subRoute ? route.subRoute.filter(filterValidRoute) : [];
          return route;
        }
        return undefined;
      };
      Object.values(cloneDeep(BaseRoutes.Admin)).forEach(route => {
        fullRoutes = fullRoutes.concat(route);
      });
      fullRoutes = fullRoutes.filter(filterValidRoute);
    } else {
      Object.values(cloneDeep(BaseRoutes.Guest)).forEach(route => {
        fullRoutes = fullRoutes.concat(route);
      });
    }
    if (routeLayer.length === 0) {
      result = fullRoutes;
    }
    for (let i = 0; i < routeLayer.length; i += 1) {
      if (!hadResult) {
        const recentRouteObject = fullRoutes.find(route => route.id === routeLayer[i]);
        if (recentRouteObject && recentRouteObject.subRoute) {
          result = recentRouteObject.subRoute;
          hadResult = true;
        }
      }
      if (hadResult && result) {
        const recentRouteObject = result.find(route => route.id === routeLayer[i]);
        if (recentRouteObject && recentRouteObject.subRoute) {
          result = recentRouteObject.subRoute;
        }
      }
    }
    if (result) {
      return result;
    }
    return [];
  }, [storeUser.userIsLogin]);
  const validReDirect = useMemo<string>(() => {
    if (storeUser.userIsLogin && validRoutes.length > 0) {
      return signInRedirect || validRoutes[0].route;
    }
    if (validRoutes.length > 0) {
      return noSignInRedirect || validRoutes[0].route;
    }
    return '';
  }, [storeUser.userIsLogin, signInRedirect, noSignInRedirect, validRoutes]);
  /* Main */
  return useMemo(
    () => ({
      routes: validRoutes,
      redirect: validReDirect
    }),
    [validRoutes, validReDirect]
  );
}
